import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Contact } from 'src/app/shared/models/iContact/contact/contact';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, AbstractControl } from '@angular/forms';
import { SelectItem, ConfirmationService } from 'primeng/api';
import { ToastrService } from 'ngx-toastr';
import { ContactNewComponent } from '../contact-new/contact-new.component';
import * as _ from 'underscore';
import { Pays } from 'src/app/shared/models/iContact/global/pays';
import { AutoComplete } from 'primeng/autocomplete';
import { DialogService } from 'primeng/dynamicdialog';
import * as async from 'async';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { ContactCategoryDto, DropdownContactTypeDTO, LowInformationsDTO } from 'src/app/shared/interfaces';
import { HttpErrorResponse } from '@angular/common/http';
import { ContactsGlobalService } from 'src/app/shared/services/contacts-global.service';
import { LinkedMembersInfos } from 'src/app/shared/models/iContact/global/contacts-lien-membres';
import { LowInformations } from 'src/app/shared/models/iContact/global/low-informations';
import { catchError, forkJoin, of } from 'rxjs';
@Component({
  selector: 'app-contact-company-linked',
  templateUrl: './contact-company-linked.component.html',
  styleUrls: ['./contact-company-linked.component.scss'],
})
export class ContactCompanyLinkedComponent implements OnInit {
  public contactFiltered: Contact[] = []; // without existing links
  public filteredContacts: Contact[];
  // @Input() public globalSubmitE: Observable<void>; // global submit click button
  // private submitSubscription: Subscription; // listen on global submit click button
  @Input() public contact: Contact;
  @Output() public memberLinkCount = new EventEmitter<number>();
  @Output() public editEnabled = new EventEmitter<boolean>();
  @ViewChild(AutoComplete) myAutoComplete: AutoComplete;

  public membersForm: UntypedFormGroup;
  public multiForm: UntypedFormGroup = new UntypedFormGroup({
    societeId: new UntypedFormControl(null),
    lienId: new UntypedFormControl(null),
    titre: new UntypedFormControl(null),
    relationId: new UntypedFormControl(null),
    adresse: new UntypedFormControl(null),
    codePostal: new UntypedFormControl(null),
    localite: new UntypedFormControl(null),
    telephone: new UntypedFormControl(null),
    fax: new UntypedFormControl(null),
    gsm: new UntypedFormControl(null),
    site: new UntypedFormControl(null),
    mail: new UntypedFormControl(null),
    nePasUtiliser: new UntypedFormControl(false),
  });
  public typesRelations: SelectItem[] = [];
  public defaultRelation: SelectItem;

  // $$$$$$$$$$$$$$$$ V2 $$$$
  public contactName: string;
  public linksSoc: LinkedMembersInfos[] = [];

  public columns = [
    {
      field: 'name',
      header: 'Nom',
    },
    {
      field: 'titre',
      header: 'Titre',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'adresse',
      header: 'Adresse',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'cp',
      header: 'CP',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'localite',
      header: 'Localité',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'gsm',
      header: 'GSM',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'fax',
      header: 'FAX',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'mail',
      header: 'email',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'site',
      header: 'Site',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'telephone',
      header: 'Telephone',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'relation',
      header: 'Relation',
      format: (value: string): string => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'actions',
      header: 'Actions',
      format: (): string => {
        return "<i class='bi bi-pencil-fill'></i>";
      },
      click: (value) => {
        this.patchValue(value);
      },
    },
  ];
  public codeTvaList: SelectItem[] = [
    { label: 'BE', value: 'BE' },
    { label: 'FR', value: 'FR' },
    { label: 'LU', value: 'LU' },
    { label: 'NL', value: 'NL' },
    { label: 'DE', value: 'DE' },
  ];

  public isDisabled: boolean;
  public countriesList: Pays[];
  public contactTypes: Array<DropdownContactTypeDTO> = [];
  public filterContactType = '';
  public multiSociete = false;
  activeState: boolean[] = [true, false];
  public update = false;
  public contacts: LowInformations[] = [];
  public contactInit: LowInformations[] = [];
  constructor(
    private formbuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private confirmationService: ConfirmationService,
    private dialogService: DialogService,
    public spinner: NgxSpinnerService,
    private contactsService: ContactsService,
    private contactsGlobalService: ContactsGlobalService
  ) {}

  ngOnInit(): void {
    this.setDatas();
  }

  private setDatas(): void {
    this.spinner.show();
    this.initForm();
    forkJoin({
      types: this.contactsGlobalService.fetchMappedContactTypesToPrimeNGDropdowns().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors du chargement des types de contacts');
          return of([]);
        })
      ),
      typesRelations: this.contactsGlobalService.fetchContactCategories().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors du chargement des types de catégories de contacts');
          return of([]);
        })
      ),
      contactsIC: this.contactsService.getLowInformationsContactsiCourrier().pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors du chargement des contacts de iCourrier');
          return of([]);
        })
      ),
      links: this.contactsGlobalService.getSocietesV2(this.contact.id).pipe(
        catchError(() => {
          this.spinner.hide();
          this.toastr.error('Une erreur est survenue lors du chargement des liens de membres de société');
          return of(null);
        })
      ),
    }).subscribe({
      next: (value) => {
        this.contactTypes = value.types;
        this.formatCategoryContactTypes(value.typesRelations);
        this.setAllContacts(value.contactsIC, true);
        this.multiSociete = value.links.liensMembres.length > 1 ? true : false;
        this.linksSoc = value.links.liensMembres.map((item) => new LinkedMembersInfos(item, this.typesRelations));
        this.memberLinkCount.emit(this.linksSoc.length);
        this.spinner.hide();
      },
    });
  }
  private initForm(): void {
    this.membersForm = this.formbuilder.group({
      societeId: new UntypedFormControl(null),
    });
  }
  private formatCategoryContactTypes(typesRelations: ContactCategoryDto[]): void {
    this.typesRelations = [];
    typesRelations.forEach((item) => {
      this.typesRelations.push({
        label: item.typeContact,
        value: item.id,
      });
    });
    this.typesRelations = _.sortBy(this.typesRelations, 'label');
  }

  private setAllContacts(contacts: LowInformationsDTO[], addInitContactData?: boolean): void {
    const temp: LowInformations[] = contacts.filter((x) => x.typeSociete === true).map((contact) => new LowInformations(contact));
    this.contacts = _.sortBy(temp, 'label');
    addInitContactData ? (this.contactInit = this.contacts) : null;
  }

  toggle(index: number): void {
    this.activeState[index] = !this.activeState[index];
  }

  get f(): { [key: string]: AbstractControl } {
    return this.membersForm.controls;
  }

  filterContact(event): void {
    if (event.value) {
      this.contacts = [];
      this.filterContactType = event.value;
      const temp = [];

      this.contactInit.map((x) => {
        if (x.typeContactID === event.value && x.nePlusUtiliser !== true) {
          temp.push(x);
        }
      });
      this.contacts = temp;
    } else {
      this.filterContactType = null;
      this.contacts = this.contactInit;
    }
  }

  addContact(): void {
    this.contactsGlobalService.putSocieteUniqV2(this.contact.id, this.membersForm.value.societeId).subscribe({
      next: () => {
        this.toastr.success('La société a bien été lié au contact');
        this.ngOnInit();
      },
    });
  }

  addMultiple(): void {
    this.contactsGlobalService.postSocietesV2(this.contact.id, this.multiForm.value.societeId, this.multiForm.value).subscribe({
      next: () => {
        this.toastr.success('La société a bien été lié au contact');
        this.ngOnInit();
      },
    });
  }
  switch(multiSociete): void {
    if (multiSociete) {
      this.contactsGlobalService.enableMultiSociete(this.contact.id).subscribe({
        next: () => {
          this.toastr.success('Le contact est en mode multi société');
        },
      });
    }
  }

  patchValue(contact): void {
    if (contact.value) {
      this.contactsService.fetchContact(contact.value, 'iCourrier').subscribe({
        next: (res) => {
          this.multiForm.patchValue({
            societeId: res.id,
            titre: res.titre,
            adresse: res.adressePrincipale.impression_Adresse,
            codePostal: res.adressePrincipale.impression_CodePostal,
            localite: res.adressePrincipale.impression_Localite,
            telephone: res.adressePrincipale.telephone,
            fax: res.adressePrincipale.fax,
            gsm: res.adressePrincipale.gsm,
            site: res.adressePrincipale.site,
            mail: res.adressePrincipale.mail,
          });
        },
      });
    } else {
      this.multiForm.patchValue({
        societeId: contact.societeId,
        lienId: contact.id,
        titre: contact.titre,
        adresse: contact.adresse,
        codePostal: contact.codePostal,
        localite: contact.localite,
        telephone: contact.telephone,
        fax: contact.fax,
        gsm: contact.gsm,
        site: contact.site,
        mail: contact.mail,
      });
      this.toggle(0);
      this.toggle(1);
      this.update = true;
    }
  }

  updateLink(): void {
    this.contactsGlobalService.putSocietesV2(this.contact.id, this.multiForm.value.lienId, this.multiForm.value).subscribe({
      next: () => {
        this.toastr.success('Les informations de la société ont été mis à jour');
        this.ngOnInit();
      },
    });
  }

  deleteMultiple(arrayToDelete: LinkedMembersInfos[]): void {
    if (arrayToDelete.length < this.linksSoc.length) {
      async.eachSeries(
        arrayToDelete,
        (item, next) => {
          this.contactsGlobalService.deleteSocietesV2(this.contact.id, item.id, false).subscribe({
            next: () => {
              next();
            },
          });
        },
        () => {
          this.toastr.success('Les éléments ont été supprimés');
          this.ngOnInit();
        }
      );
    } else {
      this.confirmationService.confirm({
        message: 'Transférer cette société comme société principale ?',
        accept: () => {
          async.eachSeries(
            arrayToDelete,
            (item, next) => {
              this.contactsGlobalService.deleteSocietesV2(this.contact.id, item.id, true).subscribe({
                next: () => {
                  next();
                },
              });
            },
            () => {
              this.toastr.success('Les éléments ont été supprimés');
              this.ngOnInit();
            }
          );
        },
        reject: () => {
          async.eachSeries(
            arrayToDelete,
            (item, next) => {
              this.contactsGlobalService.deleteSocietesV2(this.contact.id, item.id, false).subscribe({
                next: () => {
                  next();
                },
              });
            },
            () => {
              this.toastr.success('Les éléments ont été supprimés');
              this.ngOnInit();
            }
          );
        },
      });
    }
  }

  addNew(): void {
    const ref = this.dialogService.open(ContactNewComponent, {
      styleClass: 'super-compos-modal-content',
      dismissableMask: false,
      width: '70vw',
      closable: false,
      showHeader: false,
      baseZIndex: 1000,
      data: {
        caller: 'contact',
        companyMode: true,
      },
    });
    ref.onClose.subscribe({
      next: (value) => {
        if (value) {
          this.contactsService.getLowInformationsContactsiCourrier().subscribe({
            next: (contacts) => {
              this.setAllContacts(contacts);
              this.membersForm.patchValue({
                societeId: value.id,
              });
            },
          });
        }
      },
    });
  }
}
